<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
}
</script>

<style>
body {
  margin: 0 0;
}

#app {
  font-family: Helvetica, sans-serif;
}
</style>
